// src/components/TourGuide.js

import React, { useMemo } from 'react';
import { Joyride } from 'react-joyride';
import useWindowSize from '../hooks/useWindowSize';

const joyrideOptions = {
  arrowColor: '#fff',
  backgroundColor: '#fff',
  primaryColor: '#58595b',
  textColor: '#231f20',
  zIndex: 10000,
  skipBeacon: true,
};

const joyrideStyles = {
  tooltipContainer: {
    textAlign: 'left',
  },
  buttonPrimary: {
    borderRadius: '20px',
  },
  buttonBack: {
    marginRight: 10,
  },
};

const TourGuide = ({ run, stepIndex, callback, hasVideoAnalysis }) => {
  const { width } = useWindowSize();

  const steps = useMemo(() => {
    const isMobile = width <= 768;
    const allSteps = [
      // 0. Intro
      {
        target: 'body',
        placement: 'center',
        title: 'Welkom bij Doorloopjes',
        content: 'We laten je in een paar stappen zien waar je alles vindt.',
      },

      // 1. Home
      {
        target: '.sidebar-btn[href="/dashboard"]',
        content: 'Dit is je startpagina.',
        placement: isMobile ? 'top' : 'right',
      },

      // 2. Doorloopjes
      {
        target: '.sidebar-btn[href="/doorloopjes"]',
        content: 'Hier vind je alle doorloopjes, per thema of boek.',
        placement: isMobile ? 'top' : 'right',
      },

      // 3. Nieuws
      {
        target: '.sidebar-btn[href="/nieuws"]',
        content: 'Alle nieuwsberichten op één plek.',
        placement: isMobile ? 'top' : 'right',
      },

      // 4. Video Analyse (alleen als gebruiker toegang heeft)
      ...(hasVideoAnalysis ? [{
        target: '.sidebar-btn[href="/video-analyse"]',
        content: 'Film je les en krijg feedback van de AI.',
        placement: isMobile ? 'top' : 'right',
      }] : []),

      // 5. Clusters
      {
        target: '.sidebar-btn[href="/cluster-builder-test"]',
        content: 'Stel je eigen cluster van doorloopjes samen.',
        placement: isMobile ? 'top' : 'right',
      },

      // 6. Kennisbank (Achtergronden)
      {
        target: '.sidebar-btn[href="/achtergronden"]',
        content: 'Achtergronden: artikelen en Waarom/How-stukken.',
        placement: isMobile ? 'top' : 'right',
      },

      // 7. Webinars
      {
        target: '.sidebar-btn[href="/webinars"]',
        content: 'Meld je aan voor webinars of kijk opnames terug.',
        placement: isMobile ? 'top' : 'right',
      },

      // 8. Contact
      {
        target: '.sidebar-contact-btn',
        content:
          'Heb je vragen? Via Contact open je de contact-overlay (zelfde als op de landingspagina).',
        placement: isMobile ? 'top' : 'right',
      },

      // 9. Profiel
      {
        target: '.user-profile-menu',
        content: 'Hier vind je je profielinstellingen en kun je uitloggen.',
        placement: isMobile ? 'bottom-end' : 'left',
      },
    ];
    return allSteps;
  }, [width, hasVideoAnalysis]);

  const locale = {
    back: 'Terug',
    skip: 'Overslaan',
    last: 'Klaar',
    next: `Volgende (Stap ${stepIndex + 1} van ${steps.length})`,
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      stepIndex={stepIndex}
      onEvent={callback}
      continuous={true}
      styles={joyrideStyles}
      locale={locale}
      options={{
        ...joyrideOptions,
        /**
         * Geen 'X' (sluit) knopje: gebruikers gebruiken "Overslaan" of "Volgende".
         * "Overslaan" staat er niet op de eerste stap, wel op alle andere.
         */
        buttons: stepIndex > 0 ? ['back', 'skip', 'primary'] : ['back', 'primary'],
        /**
         * Optioneel: laat op de eerste stap afsluiten via ESC of overlay-klik niet toe.
         * (Daarna wel.)
         */
        dismissKeyAction: stepIndex === 0 ? false : 'close',
        overlayClickAction: stepIndex === 0 ? false : 'close',
      }}
    />
  );
};

export default TourGuide;
